import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 564,
    },
    '& .modal-base-content': {
        padding: 16,
    },
});

export const Content = styled('div')({
    display: 'grid',
    gridGap: '16px 24px',
    gridTemplateColumns: 'calc(50% - 12px) calc(50% - 12px)',
    '& .companies-autocomplete': {
        gridColumn: '1 / span 2',
    },
    '@media (max-width: 600px)': {
        gridTemplateColumns: '100%',
        gridGap: '16px',
        '& .companies-autocomplete': {
            gridColumn: '1 / span 1',
        },
    },
});

export const CheckboxWrapper = styled('div')({
    display: 'flex',
    alignItems: 'center',
    height: 40,
    '& .MuiCheckbox-root': {
        padding: 4,
    },
});

export const ActivityWrapper = styled('div')({
    display: 'flex',
    gap: 24,
    '@media (max-width: 600px)': {
        flexDirection: 'column',
        gap: 0,
    },
});
